import { object, collection, array, string } from '@gogame/schemas';

export const breakdownPathSchema = collection(
  object({
    breakdownId: string(),
    openRows: array(string()).default([]),
  })
).default([]);
